(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pawnovi-product-purchase-promos"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.pawNoviCouponCopyBound) return;
    window.pawNoviCouponCopyBound = true;

    const copyText = async (value) => {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
        return;
      }

      const field = document.createElement('textarea');
      field.value = value;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      const copied = document.execCommand('copy');
      field.remove();
      if (!copied) throw new Error('copy_failed');
    };

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-pn-copy-code]');
      if (!button) return;

      const status = document.getElementById(button.getAttribute('aria-describedby'));
      try {
        await copyText(button.dataset.code);
        button.textContent = button.dataset.successLabel;
        if (status) status.textContent = button.dataset.successLabel;
      } catch (error) {
        button.textContent = button.dataset.errorLabel;
        if (status) status.textContent = button.dataset.errorLabel;
      }

      window.setTimeout(() => {
        button.textContent = button.dataset.defaultLabel;
      }, 1800);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
